/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type CheckModelCatalogHealthRequest = {
  id: string;
};

/** @internal */
export const CheckModelCatalogHealthRequest$inboundSchema: z.ZodType<
  CheckModelCatalogHealthRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
});
/** @internal */
export type CheckModelCatalogHealthRequest$Outbound = {
  id: string;
};

/** @internal */
export const CheckModelCatalogHealthRequest$outboundSchema: z.ZodType<
  CheckModelCatalogHealthRequest$Outbound,
  z.ZodTypeDef,
  CheckModelCatalogHealthRequest
> = z.object({
  id: z.string(),
});

export function checkModelCatalogHealthRequestToJSON(
  checkModelCatalogHealthRequest: CheckModelCatalogHealthRequest,
): string {
  return JSON.stringify(
    CheckModelCatalogHealthRequest$outboundSchema.parse(
      checkModelCatalogHealthRequest,
    ),
  );
}
export function checkModelCatalogHealthRequestFromJSON(
  jsonString: string,
): SafeParseResult<CheckModelCatalogHealthRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CheckModelCatalogHealthRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CheckModelCatalogHealthRequest' from JSON`,
  );
}
